import { BreakPoint } from "./breakPoint";
import { ContractDetails } from "./contractDetails";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { IContractDetailsResponseData } from "../../../setup/api/services/contract/models";
import { getContractDetails } from "../../../setup/api/services/contract";
import { ROUTES } from "../../../setup/constants";
import LoginForm from "../../authentication/login/loginForm";
import { Footer } from "../../../components/common/footer";

export const PublicContractDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [contract, setContract] = useState<IContractDetailsResponseData>();
  useEffect(() => {
    if (id)
      getContractDetails(id)
        .then((res) => {
          setContract(res.data);
        })
        .catch((error) => {
          console.error(error);
          navigate(ROUTES.CONTRACT_NOT_FOUND);
        });
  }, [id]);
  return contract ? (
    <BreakPoint
      leftElement={<LoginForm />}
      rightElement={
        <>
          <ContractDetails contract={contract} />
          <Footer />
        </>
      }
    />
  ) : null;
};
